export default __webpack_public_path__ + "static/media/miguel-lopes-19.7123bc3f.jpg";